import Head from "next/head";
import { getRobotsMetaContent } from "utils/utils";

const structuredOrgData = {
  "@context": "https://schema.org",
  "@type": "EducationalOrganization",
  name: "CoLearn",
  url: `${process.env.NEXT_PUBLIC_SITE_URL}/bimbel`,
  logo: `${process.env.NEXT_PUBLIC_SITE_URL}/assets/colearn_logo.png`,
  sameAs: [
    "https://www.facebook.com/colearn.id",
    "https://www.instagram.com/colearn.id/",
    "https://www.youtube.com/c/colearn",
    "https://www.linkedin.com/company/colearnid/",
    "https://twitter.com/colearn_id",
    "https://www.tiktok.com/@colearn.id"
  ]
};

export const BimbelHomeSEO: React.FC = () => (
  <Head>
    <title>
      Bimbel online CoLearn. Hobi jalan terus, nilai matematika tetep bagus!
    </title>
    <meta
      name="description"
      content="Aplikasi bimbel online yang bikin cepet ngerti. Cuma 90.000 per bulan. Tersedia untuk SD, SMP, dan SMA."
    />
    <meta
      name="keywords"
      content="Kelas online, cara daftar colearn, tutor online, colearn bayar berapa, ngajar, soal matematika, bimbel, les matematika, les fisika, les kimia, SD, SMP, SMA, PJJ, PTM, guru les, apk belajar, guru bimbel, belajar online, kelas gratis, les online, UTBK, PAS, PTS, PTN, SNMPTN, UN, asesmen nasional, latihan soal, bimbingan belajar, jerome polin"
    />

    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredOrgData) }}
    />

    <meta
      property="og:title"
      content="	
      Bimbel online CoLearn. Harga mulai dari Rp90.000 per bulan!"
    />
    <meta
      property="og:description"
      content="Aplikasi bimbel online yang bikin cepet ngerti. Mulai Rp90.000 per bulan, bersama guru Matematika, Fisika, Kimia terbaik. Tersedia untuk SD, SMP, dan SMA."
    />
    <meta
      property="og:image"
      content={`${process.env.NEXT_PUBLIC_SITE_URL}/assets/share-og.jpg`}
    />
    <meta
      property="og:url"
      content={`${process.env.NEXT_PUBLIC_SITE_URL}/bimbel`}
    />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="robots" content={getRobotsMetaContent()} />
    <link
      rel="canonical"
      href={`${process.env.NEXT_PUBLIC_SITE_URL}/bimbel/`}
    />
  </Head>
);
